module.exports = "/images/Arcade.svg?6570afcaa794a91b4a8ba6fe6a1d80ab";